import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createUser,
  deleteUserAction,
  sendPasswordEmailAction,
  updatePasswordAndSendAction,
  updateUserAction,
} from "../../../store/actions/UserActions";
import UsersFormUI from "./userFormUI";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { getRbac } from "../../../services/CommonServices";

const CustomUsersForm = () => {
  const [usersData, setUsersData] = useState();
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [passwordActionLoading, setPasswordActionLoading] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getRbac());
  }, []);

  const handleFormSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    try {
      const formattedValues = {
        ...values,
        country_code: values.country_code?.replace("+", ""),
      };

      let response = null;
      if (usersData?._id) {
        response = await dispatch(
          updateUserAction({ ...formattedValues, _id: usersData._id }, navigate)
        );
      } else {
        response = await dispatch(createUser(formattedValues, navigate));
      }

      const ok =
        response?.status >= 200 && response?.status < 300;
      if (!ok) {
        toast.error(
          response?.data?.message || "Could not save team member. Please try again."
        );
        return;
      }

      if (response?.data?.data) {
        setUsersData(response.data.data);
      }
      const interceptorShowsSuccess =
        response?.data?.message &&
        response.data.message != 200 &&
        response?.config?.method !== "get";
      if (!interceptorShowsSuccess) {
        const msg =
          typeof response?.data?.message === "string" &&
          response.data.message !== "200"
            ? response.data.message
            : usersData?._id
              ? "Team member updated successfully."
              : "Team member created successfully.";
        toast.success(msg);
      }
      navigate("/users");
    } catch (error) {
      // Toast is shown by Axios interceptor for API errors
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      Swal.fire({
        title: "Delete Users?",
        text: "Are you sure you want to PERMANENTLY delete this user? This action cannot be undone!",
        // icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#BE282D",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Delete",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await dispatch(deleteUserAction(id, navigate));
          // Swal.fire("Deleted!", "Record has been deleted.", "success");
          navigate("/users");
          // optionally redirect user back to list page
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  // ROLE maps
  // const ROLE_LABEL_TO_VALUE = {
  //   "Core Team": "core_team",
  //   Mentors: "mentors",
  //   "Executive Team": "executive_team",
  //   Volunteers: "volunteers",
  // };
  // const ROLE_VALUE_TO_LABEL = Object.fromEntries(
  //   Object.entries(ROLE_LABEL_TO_VALUE).map(([k, v]) => [v, k])
  // );

  const formatISOToDateInput = (iso) => {
    if (!iso) return "";
    // try to parse and return YYYY-MM-DD (UTC date part)
    try {
      const d = new Date(iso);
      if (isNaN(d.getTime())) {
        // fallback: split at T
        return iso.split("T")[0] || "";
      }
      return d.toISOString().slice(0, 10); // YYYY-MM-DD
    } catch (e) {
      return iso.split("T")[0] || "";
    }
  };

  let initialValues = {
    firstname: "",
    lastname: "",
    email: "",
    mobile: "",
    country_code: "91",
    dob: location?.state ? formatISOToDateInput(location?.state?.dob) : "",
    organisation: "",
    role: "",
    password: "",
    status: "active",
  };

  if (location?.state) {
    initialValues = {
      ...location?.state,
      role: location?.state?.role?._id || "",
      password: location?.state?.password_regular ?? "",
      dob: formatISOToDateInput(location?.state?.dob),
    };
  }

  useEffect(() => {
    if (location?.state) {
      setUsersData(location?.state);
    }
  }, []);

  const handleSendPassword = async (id) => {
    try {
      setPasswordActionLoading(true);
      const res = await dispatch(sendPasswordEmailAction(id)); // create this action
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Could not send password", "error");
    } finally {
      setPasswordActionLoading(false);
    }
  };

  const handleUpdatePasswordAndSend = async (id, newPassword) => {
    try {
      setPasswordActionLoading(true);
      const res = await dispatch(updatePasswordAndSendAction(id, newPassword)); // create this action
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Could not update & send password", "error");
    } finally {
      setPasswordActionLoading(false);
    }
  };

  return (
    <UsersFormUI
      usersData={usersData}
      handleFormSubmit={handleFormSubmit}
      initialValues={initialValues}
      setSelectedCountry={setSelectedCountry}
      handleDeleteUser={handleDeleteUser}
      handleSendPassword={handleSendPassword}
      handleUpdatePasswordAndSend={handleUpdatePasswordAndSend}
      passwordActionLoading={passwordActionLoading}
    />
  );
};

export default CustomUsersForm;
